import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import React from 'react';
import cssVarsTheme from './theme';

export const ThemeProvider: React.FC<{ children: React.ReactNode, forceLight?: boolean }> = ({
  children,
  forceLight = false,
}) => {
  const props = forceLight ? {
    defaultMode: 'light' as const,
    storageManager: null,
  } : {};

  return (
    <MuiThemeProvider theme={cssVarsTheme} {...props}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}; 